export default __webpack_public_path__ + "static/media/holidays-city-4.cf641d5c.png";